const React = require("react");
const createReactClass = require("create-react-class");
const {ExternalLink} = require("lucide-react");

const styles = require("./styles/ParentSupportFallback.css");

module.exports = createReactClass({
	displayName: "PageParentSupport",
	// Parent Support pages (/parent/support/) will usually redirect to the Knowledge Base/Help Site
	// This is the fallback page that users will see if they visit a broken link for these pages
	// Example: https://beastacademy.com/parent/support/xyz
	render: function() {
		return (
			<div className={styles.mainContainer}>
				<div className={styles.textAndButtonContainer}>
					<div className={styles.header}>
						Looking for help? <br />
						View our support resources.
					</div>
					<div className={styles.body}>
						We've given our support pages a new home. Pop over to our updated
						help site and we'll get you sorted.
					</div>
					<a
						href="https://help.beastacademy.com/"
						className={styles.button}
						target="_blank"
						aria-label="Visit our Help Site (opens in new tab)"
						rel="noopener noreferrer"
					>
						Visit our Help Site
						<ExternalLink
							style={{width: "14px", height: "14px", marginLeft: "8px"}}
						/>
					</a>
				</div>
				<div className={styles.imageContainer}>
					<img
						alt="BA character, Ms Q, asking if you're lost"
						src={
							global.BASE_URL +
							"assets/images/logos/parent-support-fallback-img.svg"
						}
						className={styles.image}
					/>
				</div>
			</div>
		);
	},
});
